export const blobToBase64 = (blob:Blob) : Promise<string> => {

    const reader = new FileReader()
    reader.readAsDataURL(blob)
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(typeof(reader.result) === 'string'? reader.result : '')
      }
    })
  }